import * as React from 'react';
import hljs from 'highlight.js/lib/core';
import python from 'highlight.js/lib/languages/python';

import 'highlight.js/styles/vs2015.css';

export type SyntaxHighlightedCodeProps = React.PropsWithChildren<
  {} & React.HTMLProps<HTMLElement>
>;

export function SyntaxHighlightedCode(props: SyntaxHighlightedCodeProps) {
  const ref = React.useRef<HTMLElement>(null);

  React.useEffect(() => {
    registerDefaultLanguages();
  }, []);

  React.useEffect(() => {
    registerDefaultLanguages();
    const elem = ref.current;
    if (elem) {
      hljs.highlightElement(elem);
      elem.removeAttribute('data-highlighted'); // Remove the attribute to prevent re-highlighting
    }
  }, [props.className, props.children]);

  return <code ref={ref} {...props} />;
}

export function registerDefaultLanguages() {
  registerLanguage('python', python);
}

const registeredLanguages = new Set<string>();
export function registerLanguage(name: string, language: any) {
  if (!registeredLanguages.has(name)) {
    hljs.registerLanguage(name, language);
    registeredLanguages.add(name);
  }
}
